import { Location } from 'history'
import React from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgToolbarDownload from 'src/components/Svgs/SvgToolbarDownload'
import { LocationState } from 'src/redux/createRootReducer'

export interface UtilityToolbarDownloadProps {
  onClick?: () => void
  to?: Location<LocationState> | string
}

const UtilityToolbarDownload: React.FC<UtilityToolbarDownloadProps> = ({
  onClick,
  to,
}): React.ReactElement => {
  return (
    <HoverableLink
      ariaLabelSource={'Download'}
      onClick={onClick}
      to={to}
      testId="downloadOptionsBtn"
    >
      <SvgToolbarDownload />
    </HoverableLink>
  )
}

export default UtilityToolbarDownload
